import React, { useState, useEffect } from 'react';
import { DownOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Form, Input, Radio, message, Upload, Checkbox, Modal, Dropdown } from 'antd';
import { request } from "@/utils";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import "./index.less";
import { convertDateToTimestamp, formatTimestampToDate, Func } from "@/utils/func";

import { baseUrl } from "@/utils/request";


export default function TransferOrderCommit() {
    const [detail, setDetail] = useState({})
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);

    const [isAgree, setIsAgree] = useState(false)

    const fetchData = async () => {
        try {
            const response = await request.get('goodseat/detail?id=' + searchParams.get("id"));
            setDetail(response.data || {})
            // console.log(response.data,'--')
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    const postData = async () => {
        try {
            const response = await request.post('goodseat_order/create', {
                good_seat_id: detail.id,
                buy_seats_amount: searchParams.get("num") * 1,
                mobile: JSON.parse(sessionStorage.getItem('user'))?.mobile,
                meal_deposit: detail.meal_deposit * 1 * searchParams.get('num'),
                reservation_service_charge: detail?.subscription_price * 1 * searchParams.get('num'),
                reservation_total_amount: (detail?.subscription_price * 1 + detail?.meal_deposit * 1) * searchParams.get('num')
            }); // 使用封装好的Axios实例发送GET请求
            console.log(response, 'response')
            if (response.code) {
                message.error(response.msg)
            } else {
                sessionStorage.setItem('orderId', response.data.id)
                navigate('/pay?id=' + response.data.id + '&sn=' + response.data.order_no + '&type=1')
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    const suresub = () => {
        if (!isAgree) {
            message.error("请阅读并同意预约协议")
            return
        }
        //提交预约
        postData()
    };

    useEffect(() => {
        console.log(searchParams)
        fetchData();
    }, [])

    return (
        <div className="order-commit">
            <div className="order-commit-content">
                <div>
                    <Button type="cancel" style={{ with: "74px", height: "32px", marginTop: "20px", color: "#999999", borderRadius: "4px" }}
                        onClick={() => navigate(-1)}>
                        返回
                    </Button>
                </div>

                <div className="order-commit-info-content">
                    <div className="commit-head">{detail.name}</div>
                    <div className="commit-item">
                        <div className="commit-item-label">预约时间:</div>
                        {formatTimestampToDate(detail?.reservation_date_confirm)}  {detail?.reservation_time_confirm}
                    </div>
                    <div className="commit-item">
                        <div className="commit-item-label">预定数量:</div>
                        {searchParams.get('num')}人
                    </div>
                </div>
                <div className="order-commit-info-content-no-shadow">
                    <div className="commit-desc-head">订位费用</div>
                    <div className="commit-desc-item">
                        <div className="commit-item-label">预约费:</div>
                        ￥{detail.subscription_price}x{searchParams.get('num')}
                    </div>
                    <div className="commit-desc-item">
                        <div className="commit-item-label">套餐押金:</div>
                        ￥{detail?.meal_deposit}x{searchParams.get('num')}
                        <div style={{color:'#ea0025'}}>（押金不抵扣餐费，用餐后点击“就餐完成”，上传账单小票退款）</div>
                    </div>
                    <div className="commit-desc-item">
                        <div className="commit-item-label">总计:</div>
                        ￥{((detail?.subscription_price * 1 + detail?.meal_deposit * 1) * searchParams.get('num')).toFixed(2)}
                    </div>
                </div>

                <div className="commit-sub-price-desc-content">
                    <div className="font-weight-bold">购买须知</div>
                    <div style={{ color: "#666666" }} dangerouslySetInnerHTML={{__html:detail?.shopping_notice?.replace(/ /g, '&nbsp;').replace(/\n|↵/g, '<br/>')}}>
                    </div>
                </div>
                <div className="commit-read">
                    <Checkbox className="commit-agreement-section" checked={isAgree} onChange={(e) => { setIsAgree(e.target.checked) }} /> <span>我已阅读并同意</span>
                    <span className="commit-agreement-font" onClick={() => { window.open("/userAgreement?typ=7", "_blank") }}>《订位协议》</span>
                </div>
            </div>
            <div className="order-commit-footer">
                <div className="order-commit-footer-content">
                    <div className="cancel-btn" onClick={() => { navigate(-1) }}>取消预约</div>
                    <div className="sure-btn" onClick={suresub}>确定预约</div>
                </div>
            </div>
        </div>
    )
}
